import { pushToDataLayer } from './dataLayer';

export type AnalyticsEventParams = Record<
    string,
    string | number | boolean | undefined | null
>;

function normalizeParams(
    params: AnalyticsEventParams,
): Record<string, unknown> {
    const normalized: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null) {
            normalized[key] = value;
        }
    }
    return normalized;
}

/** Always pushes to dataLayer so GTM can react. */
export function pushAnalyticsEvent(
    eventName: string,
    params: AnalyticsEventParams = {},
): void {
    pushToDataLayer(eventName, normalizeParams(params));
}

export function pushGaCommandToDataLayer(
    cmd: string,
    ...args: unknown[]
): void {
    if (cmd === 'event' && typeof args[0] === 'string') {
        const eventName = args[0];
        const params = (args[1] as AnalyticsEventParams) ?? {};

        if (eventName === 'conversion') {
            pushAnalyticsEvent('google_ads_conversion', params);
            return;
        }

        pushAnalyticsEvent(eventName, params);
        return;
    }

    if (
        cmd === 'newsletter_subscription' ||
        cmd === 'careers_newsletter_subscription'
    ) {
        pushAnalyticsEvent(cmd, {
            email: typeof args[0] === 'string' ? args[0] : undefined,
            list:
                typeof args[1] === 'string' || args[1] === null
                    ? args[1] ?? undefined
                    : undefined,
        });
    }
}
